<template>
  <v-text-field
    @click="findAddress"
    readonly
    prepend-inner-icon="mdi-map-legend"
    variant="outlined"
    label="기관 주소"
    type="text"
    v-model="address01"
    maxlength="150"
    color="indigo"
    autocomplete="off"
  />
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";

interface Props {
  addr: string;
}

const props = defineProps<Props>();
const emit = defineEmits<{
  (e: 'updateAddress', value: { address: string }): void;
}>();

const zoneCode = ref("");
const address01 = ref(props.addr);

const loadDaumPostcode = () => {
  return new Promise<void>((resolve) => {
    const script = document.createElement('script');
    script.src = '//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
    script.onload = () => resolve();
    document.head.appendChild(script);
  });
};

const findAddress = async () => {
  if (!window.daum?.Postcode) {
    await loadDaumPostcode();
  }
  
  new window.daum.Postcode({
    //eslint-disable-next-line
    oncomplete: (data: any) => {
      zoneCode.value = data.zonecode;
      address01.value = data.address;

      emit("updateAddress", {
        address: address01.value,
      });
    },
  }).open();
};

onMounted(async () => {
  await loadDaumPostcode();
});
</script>
